import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  signal,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { injectNavigationEnd } from 'ngxtension/navigation-end';
import { ScreenSizeService } from '@front-share';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, FooterComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export default class LayoutComponent {
  @ViewChild('outlet') outlet!: ElementRef<HTMLDivElement>;
  router = inject(Router);
  isMobile = inject(ScreenSizeService).isMobile;
  isDetailPage = signal<boolean>(false);
  source$ = injectNavigationEnd();

  constructor() {
    this.source$.subscribe((event: NavigationEnd) => {
      if (event?.url) {
        const detailUrl = event.url.split('/');
  
        const firstUrl: boolean = 
          (detailUrl[1] === 'product' && detailUrl.length <= 3) ||
          (detailUrl[1] === 'reservation' && detailUrl.length <= 5) || 
          (detailUrl[1] === 'gallery' && detailUrl.length <= 3) ||
          (detailUrl[1] === 'policy' && detailUrl.length <= 3);
  
        this.isDetailPage.set(firstUrl);
      }
    });
  }
  
}
